import { useState, useEffect } from "react"
import { Search, X } from "lucide-react"


const TENOR_API_KEY = process.env["REACT_APP_TENOR_KEY"] || ""; // You'll need to add this to env variables
const CATEGORIES = ["Trending", "Reactions", "Memes", "Anime", "Gaming"]

export function GifPicker({ onSelect, onClose }) {
  const [search, setSearch] = useState("")
  const [gifs, setGifs] = useState([])
  const [selectedCategory, setSelectedCategory] = useState("Trending")
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    fetchGifs()
  }, [])

  const fetchGifs = async (searchTerm) => {
    setLoading(true)
    try {
      // const endpoint = searchTerm
      //   ? `https://tenor.googleapis.com/v2/search?q=${searchTerm}&key=${TENOR_API_KEY}&limit=20`
      //   : `https://tenor.googleapis.com/v2/trending?key=${TENOR_API_KEY}&limit=20`

      // const response = await fetch(endpoint)
      // const data = await response.json()
      // setGifs(data.results)
      let results = [];

      if (searchTerm) {
        // Search by query
        const res = await fetch(
          `https://tenor.googleapis.com/v2/search?q=${encodeURIComponent(searchTerm)}&key=${TENOR_API_KEY}&client_key=my_test_app&limit=20`
        );
        const data = await res.json();
        results = data.results;
      } else {
        // Get trending terms first
        const termRes = await fetch(
          `https://tenor.googleapis.com/v2/trending_terms?key=${TENOR_API_KEY}&client_key=my_test_app`
        );
        const termData = await termRes.json();
        const terms = termData.results?.slice(0, 3) || [];
      
        // Fetch GIFs for the top trending terms (e.g., top 3)
        const gifsArrays = await Promise.all(
          terms.map((term) =>
            fetch(
              `https://tenor.googleapis.com/v2/search?q=${encodeURIComponent(term)}&key=${TENOR_API_KEY}&client_key=my_test_app&limit=6`
            ).then((r) => r.json())
          )
        );
        // Flatten all results
        results = gifsArrays.flatMap((g) => g.results || []);
      }
      
      setGifs(results);
      

    } catch (error) {
      console.error("Error fetching GIFs:", error)
    }
    setLoading(false)
  }

  const handleSearch = (value) => {
    setSearch(value)
    if (value.length > 2) {
      fetchGifs(value)
    }
  }

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50">
      <div className="bg-white dark:bg-gray-900 rounded-xl shadow-xl w-full max-w-2xl max-h-[80vh] overflow-hidden">
        <div className="flex items-center justify-between p-4 border-b border-gray-200 dark:border-gray-800">
          <h2 className="text-xl font-bold dark:text-white">Select a GIF</h2>
          <button onClick={onClose} className="p-2 rounded-lg hover:bg-gray-100 dark:hover:bg-gray-800">
            <X className="w-5 h-5 text-gray-500" />
          </button>
        </div>

        <div className="p-4">
          <div className="relative mb-4">
            <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 w-5 h-5" />
            <input
              type="text"
              value={search}
              onChange={(e) => handleSearch(e.target.value)}
              placeholder="Search GIFs..."
              className="w-full pl-10 pr-4 py-2 rounded-xl bg-gray-100 dark:bg-gray-800 border-0 focus:outline-none focus:ring-2 focus:ring-purple-500 dark:text-white"
            />
          </div>

          <div className="flex gap-2 mb-4 overflow-x-auto pb-2">
            {CATEGORIES.map((category) => (
              <button
                key={category}
                onClick={() => setSelectedCategory(category)}
                className={`px-4 py-2 rounded-xl whitespace-nowrap ${
                  selectedCategory === category
                    ? "bg-purple-500 text-white"
                    : "bg-gray-100 dark:bg-gray-800 text-gray-700 dark:text-gray-300 hover:bg-gray-200 dark:hover:bg-gray-700"
                }`}
              >
                {category}
              </button>
            ))}
          </div>

          <div className="grid grid-cols-3 gap-2 overflow-y-auto max-h-[400px]">
            {loading ? (
              <div className="col-span-3 flex items-center justify-center h-40">
                <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-purple-500" />
              </div>
            ) : (
              gifs.map((gif) => (
                <button
                  key={gif.id}
                  onClick={() => onSelect(gif.media_formats.gif.url)}
                  className="relative aspect-video rounded-lg overflow-hidden hover:ring-2 hover:ring-purple-500 focus:outline-none"
                >
                  <img
                    src={gif.media_formats.gif.url || "/placeholder.svg"}
                    alt={gif.content_description}
                    className="w-full h-full object-cover"
                  />
                </button>
              ))
            )}
          </div>
        </div>
      </div>
    </div>
  )
}

